var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"refresh-tip",attrs:{"id":"refresh-tip"}},[_c('div',{staticClass:"_tip-title"},[_vm._v(" 有新版本发布，请关闭网页重新访问 ")])])}]

export { render, staticRenderFns }